import React from 'react';
import { Modal } from 'antd';
import GlobalDivider from '../divider/GlobalDivider';

const GlobalFormModal = ({
  isVisible,
  title,
  onClose,
  onConfirm,
  children,
  loading,
  confirmText = 'Submit',
  cancelText = 'Cancel',
  drawer,
  modelTitle,
  isCustomWidth,
}) => {
  return (
    <>
      <Modal
        width={drawer ? 650 : isCustomWidth ? isCustomWidth : '70vw'}
        open={isVisible}
        onCancel={onClose}
        onOk={onConfirm}
        confirmLoading={loading}
        okText={confirmText}
        cancelText={cancelText}
        footer={false}
        centered={drawer ? true : false}
        destroyOnHidden
        title={
          <div style={{ textAlign: 'center', marginBottom: '8px' }}>
            {modelTitle || title || ''}
          </div>
        }
      >
        {drawer && <GlobalDivider name={title} />}
        {children}
      </Modal>
    </>
  );
};

export default GlobalFormModal;
